import type { HTMLProps, ReactNode } from 'react'
import clsx from 'clsx'
import useId from '../../../../shared/helpers/useId'
import Heading from '../../../../components/heading/Heading'
import type { HelpProps } from '../../../../components/help-button/HelpButtonInline'
import HelpButtonInline, {
  HelpButtonInlineContent,
} from '../../../../components/help-button/HelpButtonInline'
import type { HeadingLevel } from '../../../../components/heading/Heading'
import type { ComponentProps } from '../../types'
import withComponentMarkers from '../../../../shared/helpers/withComponentMarkers'

export type FormSubHeadingProps = ComponentProps & {
  /** The heading level to render (h2–h6). Defaults to `3`. */
  level?: HeadingLevel
  /** Configuration for an inline help button shown next to the heading. */
  help?: HelpProps
  children?: ReactNode
} & Omit<HTMLProps<HTMLElement>, 'size'>

function SubHeading({ level, ...props }: FormSubHeadingProps) {
  const { help, className, children, ...rest } = props
  const helpId = useId()
  const hasHelp = help?.title || help?.content

  return (
    <>
      <Heading
        className={clsx('dnb-forms-sub-heading', className)}
        level={level || 3}
        skipCorrection
        size="medium"
        {...rest}
      >
        {children}
        {hasHelp && (
          <HelpButtonInline
            left="x-small"
            contentId={helpId}
            help={help}
          />
        )}
      </Heading>

      {hasHelp && (
        <HelpButtonInlineContent
          top="x-small"
          contentId={helpId}
          help={help}
        />
      )}
    </>
  )
}

withComponentMarkers(SubHeading, {
  _supportsSpacingProps: true,
  _isHeadingElement: true,
})

export default SubHeading
